// ═══════════════════════════════════════════════════════════════
// documentTerminology — Vocabulaire méta du module COM/Écrivain
// S57-F : le module s'adapte au format (roman, thèse, rapport, doc…)
// ═══════════════════════════════════════════════════════════════
//
// Le mot "Livre" et "Chapitre" sont trop spécifiques au registre essai/roman.
// Le module COM couvre tout acte scriptural (humain + IA intégré) : thèse,
// mémoire, rapport, article long, doc technique, livre blanc, etc.
//
// Ce helper mappe un `genre` en vocabulaire d'interface cohérent.
// Les tables SQL restent nommées book_chapters / books (stable), seuls les
// labels UI et le prompt système adaptent les mots au contexte.
//
// API : getTerms(genre) → { docLabel, docArticle, unitSingular, unitPlural,
//                            unitShort, actionVerb, workspace, genreOptions }
// ═══════════════════════════════════════════════════════════════

const DEFAULT_GENRE = 'essai';

// Ordre = ordre d'affichage dans les dropdowns UI
const GENRES = [
    { id: 'essai',         docLabel: 'Essai',        docArticle: 'un',  unitSingular: 'Chapitre', unitPlural: 'Chapitres', unitShort: 'chap.', actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'roman',         docLabel: 'Roman',        docArticle: 'un',  unitSingular: 'Chapitre', unitPlural: 'Chapitres', unitShort: 'chap.', actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'manuel',        docLabel: 'Manuel',       docArticle: 'un',  unitSingular: 'Chapitre', unitPlural: 'Chapitres', unitShort: 'chap.', actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'livre_blanc',   docLabel: 'Livre blanc',  docArticle: 'un',  unitSingular: 'Section',  unitPlural: 'Sections',  unitShort: '§',     actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'these',         docLabel: 'Thèse',        docArticle: 'une', unitSingular: 'Partie',   unitPlural: 'Parties',   unitShort: 'partie',actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'memoire',       docLabel: 'Mémoire',      docArticle: 'un',  unitSingular: 'Partie',   unitPlural: 'Parties',   unitShort: 'partie',actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'rapport',       docLabel: 'Rapport',      docArticle: 'un',  unitSingular: 'Section',  unitPlural: 'Sections',  unitShort: '§',     actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'article_long',  docLabel: 'Article',      docArticle: 'un',  unitSingular: 'Section',  unitPlural: 'Sections',  unitShort: '§',     actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'doc_technique', docLabel: 'Document',     docArticle: 'un',  unitSingular: 'Section',  unitPlural: 'Sections',  unitShort: '§',     actionVerb: 'rédiger', workspace: 'Atelier' },
    { id: 'autre',         docLabel: 'Document',     docArticle: 'un',  unitSingular: 'Section',  unitPlural: 'Sections',  unitShort: '§',     actionVerb: 'rédiger', workspace: 'Atelier' },
];

const BY_ID = Object.fromEntries(GENRES.map(g => [g.id, g]));

export function getTerms(genre) {
    return BY_ID[genre] || BY_ID[DEFAULT_GENRE];
}

export function listGenres() {
    return GENRES.map(g => ({ id: g.id, label: g.docLabel }));
}

export function getTermsFromBook(book) {
    return getTerms(book?.genre || DEFAULT_GENRE);
}
